import { IconButton, SxProps, Theme } from '@mui/material';

import { Iconify } from './iconify';
import { useNavigate } from 'react-router-dom';

interface Props {
  sx?: SxProps<Theme>;
  onClick?: VoidFunction;
}

const GoBackButton = ({ sx, onClick }: Props) => {
  const navigation = useNavigate();

  return (
    <IconButton
      sx={{
        backgroundColor: 'white',
        boxShadow: '0px 2px 5px rgba(73, 67, 67, 0.2)',
        ...sx,
      }}
      onClick={() => (onClick ? onClick() : navigation(-1))}
    >
      <Iconify icon={'ic:round-arrow-back-ios'} fontSize={20} color={'black'} />
    </IconButton>
  );
};

export { GoBackButton };
